<template>
  <v-bottom-navigation :elevation="5" density="compact" base="#7f182f" :class="$vuetify.breakpoint.smAndDown ? 'mt-15' : ''">
    <div class="bottom-nav-scroll">
      <v-btn to="/" :class="{ 'active-btn': $route.path === '/' }">
        <v-icon>mdi-home</v-icon>
        <span>Inicio</span>
      </v-btn>
      <v-btn to="/torneos" :class="{ 'active-btn': $route.path.includes('/torneos') }">
        <v-icon>mdi-trophy</v-icon>
        <span>Torneos</span>
      </v-btn>
      <v-btn to="/juegos" :class="{ 'active-btn': $route.path === '/juegos' }">
        <v-icon>mdi-basketball</v-icon>
        <span>Juegos</span>
      </v-btn>
      <v-btn to="/jugadores" :class="{ 'active-btn': $route.path === '/jugadores' }">
        <v-icon>mdi-account-group</v-icon>
        <span>Jugadores</span>
      </v-btn>
      <v-btn to="/game_log" :class="{ 'active-btn': $route.path === '/game_log' }">
        <v-icon>mdi-file-document</v-icon>
        <span>Game Log</span>
      </v-btn>
      <v-btn to="/lideres" :class="{ 'active-btn': $route.path === '/lideres' }">
        <v-icon>mdi-star</v-icon>
        <span>Líderes</span>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" :class="{ 'active-btn': $route.path.includes('/records') }">
            <v-icon>mdi-chart-bar</v-icon>
            <span>Records</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/records_individuales">
            <v-list-item-title>Individuales</v-list-item-title>
          </v-list-item>
          <v-list-item to="/records_equipo">
            <v-list-item-title>Equipo</v-list-item-title>
          </v-list-item>
          <v-list-item to="/records_rivales">
            <v-list-item-title>Rivales</v-list-item-title>
          </v-list-item>
          <v-list-item to="/records_coachs">
            <v-list-item-title>Entrenadores</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn to="/jugadores_ncaa" :class="{ 'active-btn': $route.path === '/jugadores_ncaa' }">
        <v-icon>mdi-school</v-icon>
        <span>NCAA</span>
      </v-btn>
    </div>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "BottomNavigation"
};
</script>

<style scoped>
.bottom-nav-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  scrollbar-color: #7f182f #eee;
}
.bottom-nav-scroll > * {
  flex: 0 0 auto;
  margin: 0 1px;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 55px !important;
    min-width: 81px !important;
    padding: 0 16px !important;
}
</style>